// theirs
import styled from 'styled-components'
// ours
import { TextQuoteHighlightProps } from '.'
import { breakpoints, typography } from '../../../styles'
import { appendLocationSingle } from '../../../utils/append-location'

export const textQuoteHighlightBaseClass = 'text-quote-highlight'

export const StyledTextQuoteHighlight = styled.div<TextQuoteHighlightProps>`
    &.${textQuoteHighlightBaseClass} {
        background: linear-gradient(180deg, #5d4997, #b8699b);
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;

        display: grid;
        grid-template-rows: ${(props) =>
            props.doesHaveNextChapter ? '50% 50%' : 'auto'};

        @keyframes animateHighLight {
            from {
                opacity: 0;
                transform: scaleY(0.5) translateY(4px);
            }
            to {
                opacity: 1;
                transform: scaleY(1.0); translateY(0px);
            }
        }

        .content-outer {
            justify-content: center;
            justify-items: center;
            display: grid;
        }

        .content-inner {
            display: grid;
            height: 100%;
            justify-items: center;
            place-self: center;
        }

        .text-wrapper {
            padding: 0 1rem;
            align-self: center;
            margin: 0;

            @media (min-width: ${breakpoints.lg}) {
                padding: 0;
            }

            .hl-container {
                margin: 0 -6px;
                padding: 0 6px;
                position: relative;
                display inline-flex;
                z-index: 0;

                &::before{
                    background-repeat: no-repeat;
                    background-position: top 20% left 0, bottom 20% left 0, top 20% left 50%, bottom 20% left 50%, top 20% right 0, bottom 20% right 0;
                    background-size: 20px 41%,20px 41%,calc(100% - 38px) 41%,calc(100% - 38px) 41%,20px 41%,20px 41%;
                    background-image:
                    url(${(props) =>
                        appendLocationSingle(
                            'images',
                            props.content.contentHighlight1ImageSource
                        )}),
                    url(${(props) =>
                        appendLocationSingle(
                            'images',
                            props.content.contentHighlight2ImageSource
                        )}),
                    url(${(props) =>
                        appendLocationSingle(
                            'images',
                            props.content.contentHighlight3ImageSource
                        )}),
                    url(${(props) =>
                        appendLocationSingle(
                            'images',
                            props.content.contentHighlight4ImageSource
                        )}),
                    url(${(props) =>
                        appendLocationSingle(
                            'images',
                            props.content.contentHighlight5ImageSource
                        )}),
                    url(${(props) =>
                        appendLocationSingle(
                            'images',
                            props.content.contentHighlight6ImageSource
                        )});

                    content: "";
                    top:0;
                    bottom:0;
                    right:0;
                    left:0;
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    z-index: -1;

                }
                .hl-text {
                    white-space:pre;
                }

            }
            .hl-animate::before {
                opacity: 0;
                animation: animateHighLight 0.5s 2s ease-out forwards;
            }

            .normal {
                display: block;
                max-width: 350px;
                margin-left: auto;
                margin-right: auto;

                @media (min-width: ${breakpoints.sm}) {
                    max-width: 550px;
                }

                @media (min-width: ${breakpoints.lg}) {
                    max-width: 760px;
                }

                &.last {
                    margin-bottom: 2.5rem;
                }
            }

            .highlight {
                display: block;
                font-style: normal;
                background-color: inherit;

                &.italic {
                    font-style: italic;
                }
            }

            p {
                text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.1;
                letter-spacing: 2px;
                text-align: center;
                color: #f7f6f3;

                font-size: ${typography.size.m2};
                @media (min-width: ${breakpoints.xs}) {
                    font-size: ${typography.size.m3};
                }

                @media (min-width: ${breakpoints.lg}) {
                    font-size: ${typography.size.l4};
                }
            }
        }
    }
`
